<template>
    <section class="walletPage-wrap wallet-history-main">
        <div class="container mt-2">
            <div class="payment-heading">
                <h3>{{$t('transactions', 'Transactions')}}</h3>
                <a class="filter-sec" v-if="!isFiltered" href="#history-filter-modal" data-bs-toggle="modal">
                    <img loading="lazy" src="@/assets/images/filter-outline.svg" alt="img">
                </a>
                <a class="filter-sec" v-else href="#history-filter-modal" data-bs-toggle="modal">
                    <img loading="lazy" src="@/assets/images/filter-fill.svg" alt="img">
                </a>
            </div>

            <div class="history-wrap" v-if="walletHistoryData?.length > 0">
                <div class="history-items">
                    <div class="history-item" v-for="(transaction, index) in walletHistoryData" :key="index" @click="handleTransactionDetails(transaction)">
                        <div class="history-icon bg-yellow" v-if="['pending','hold'].includes(transaction.status)">
                            <img loading="lazy" src="@/assets/images/payment-processing.svg" alt="processing-payment">
                        </div>
                        <div class="history-icon" v-if="['approve_completed','approve_in_process'].includes(transaction.status)">
                            <img loading="lazy" src="@/assets/images/payment-approved.svg" alt="request-approved">
                        </div>
                        <div class="history-icon bg-red" v-if="['reject_in_process','reject_completed','expired','cancelled'].includes(transaction.status)">
                            <img loading="lazy" src="@/assets/images/payment-rejected.svg" alt="request-rejected">
                        </div>
                        <div class="history-content">
                            <span class="history-title" :class="getTransactionStatus(transaction?.status)?.label">{{ toTitleCaseWithSpaces(transaction?.type) }} Request <span class="badge" :class="getTransactionStatus(transaction?.status)?.class">{{ getTransactionStatus(transaction?.status)?.label }}</span></span>
                            <span class="history-date">
                                <img src="@/assets/images/clock-icon.svg" alt="clock-icon" loading="lazy" />
                                {{ $dateTime.sportItemDate(transaction.created_at, 'hh:mmA') }} | {{ $dateTime.sportItemDate(transaction.created_at, 'DD MMM YYYY') }}
                            </span>
                        </div>
                        <i v-if="['pending','hold','reject_in_process','approve_in_process'].includes(transaction.status)" @click.stop="handleRefreshWalletHistory(index)" :id="'spin'+index" class="fa fa-refresh" aria-hidden="true"></i>
                        <div class="history-wet credit-color" :class="{'profit-color' : selectedStatus == 'approve_completed', 'loss-color' : selectedStatus == 'reject_completed'}">{{transaction.status == 'approve_completed' ? transaction.approved_amount : transaction.amount}}</div>
                        <!-- <div class="history-wet credit-color transactionsInformation-delete" v-if="transaction.status == 'pending'"  @click.stop="askConfirmation(transaction.c_a_tid)">
                             <img src="@/assets/images/delete-btn.png" alt="">
                        </div> -->
                    </div>
                </div>
            </div>
             <div class="noHistory-data" v-if="!globalLoader && !walletHistoryData?.length">
                No records found
            </div>
        </div>
    </section>

    <div class="modal fade modal-style history-filter-modal" id="history-filter-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">{{$t('filters', 'Filter')}}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetFilter"></button>
                </div>
                <div class="modal-body">
                    <div class="filter-form-content">
                        <div class="row">
                            <div class="col-6">
                                <div class="input-field">
                                    <label class="form-label">{{ $t('from','From')}}</label>
                                    <input type="date" class="form-control" placeholder="30-05-23" aria-label="Username" id="exampleInputFrom" aria-describedby="addon-wrapping"
                                    v-model="formDates.fromDate" @change="handleFromDate">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-field">
                                    <label class="form-label">{{ $t('to','To')}}</label>
                                    <input type="date" class="form-control" placeholder="30-05-23" aria-label="Username" id="exampleInputTo" aria-describedby="addon-wrapping" 
                                    v-model="formDates.toDate" @change="handleToDate">
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <label class="form-label">{{ $t('filter-by','Filter By')}}</label>
                            <!-- <div class="row">
                                <div class="col-6" v-for="(item, index) in options" :key="index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="filter-method"
                                        :id="'checkbox-' + item.value" :value="item.value" ref="statusOpted">
                                        <label class="form-check-label" :for="'checkbox-' + item.value">
                                            {{ item.label }}
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                            <div class="filter-flex-wrapper">
                                <div class="filter-flex-sec" v-for="(item, index) in options" :key="index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="filter-method"
                                        :id="'checkbox-' + item.value" :value="item.value" ref="statusOpted">
                                        <label class="form-check-label" :for="'checkbox-' + item.value">
                                            {{ item.label }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <label class="form-label">Filter By Request</label>
                            <div class="filter-flex-wrapper">
                                <div class="filter-flex-sec" v-for="(item, index) in transactionTypeOptions" :key="index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transaction-filter-method"
                                        :id="'transactionCheckbox-' + item.value" :value="item.value" ref="transactionStatusOpted">
                                        <label class="form-check-label" :for="'transactionCheckbox-' + item.value">
                                            {{ item.label }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="withdraw-fix-sec continue-btn">
                            <a href="javascript:void(0);" class="thm-but" data-bs-dismiss="modal" @click="getWalletHistory">{{$t('apply', 'Apply')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Confirmation
        @confirm="confirmDelete"
        @cancel="$helper.closeModal('deleteConfirmationModal')"
    />
</template>

<script>
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import {getWalletHistory, getTransactionStatus, cancelRequest} from "@template/utils"
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import Confirmation from '@/shared/components/confirmation/Confirmation.vue';
export default {
    name: 'Wallet History',
    data(){
        return{
            walletHistoryData: null,
            profitLossData: null,
            pageNo: 1,
            totalPage: 0,
            pageEntries: 10,
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approve'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
                // { label: this.$t('cancelled', 'Cancelled'), value: 'cancelled', selected:true },
            ],
            transactionTypeOptions : [
                { label: this.$t('all', 'All'), value: 3, selected:true },
                { label: this.$t('deposit', 'Deposit'), value: 1, selected:true },
                { label: this.$t('withdrawal', 'Withdrawal'), value: 2, selected:true },
            ],
            loading: false,
            selectedStatus : 'all',
            selectedTransactionType : 3,
            selectedTransactionId: null,
            selectedDates: {
                fromDate: '',
                toDate: '',
            },
        }
    },
    components: { 
        NoDataFound,
        Confirmation,
    },
    computed: {
        ...mapGetters(['globalLoader']),
        isFiltered(){
            console.log(this.selectedStatus, this.selectedTransactionType)
            if(this.selectedStatus != 'all' || this.selectedTransactionType != 3 || this.selectedDates.fromDate != this.$dateTime.getPreviousDate(2) || this.selectedDates.toDate != this.$dateTime.getcurrentDate()){
                return true
            }
            else return false
        }
    },
    created(){
        this.formDates.fromDate = this.$dateTime.getPreviousDate(2);
        this.formDates.toDate = this.$dateTime.getcurrentDate();
        this.getWalletHistory()
    },
    mounted(){
        this.$refs.statusOpted[0].checked = true;
        this.$refs.transactionStatusOpted[0].checked = true;
    },
    methods:{
        handleTransactionDetails(transaction){
            if(['pending','approve_in_process','reject_in_process','expired','hold'].includes(transaction.status)) return false
            this.gotoTransactionDetails(transaction)
        },
        askConfirmation(id) {
            this.selectedTransactionId = id
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await this.cancelRequest(this.selectedTransactionId);
        },
        handleFromDate(e) {
            if (!e.target.value) this.formDates.fromDate = this.$dateTime.getPreviousDate(3);
        },
        handleToDate(e) {
            if (!e.target.value) this.formDates.toDate = this.$dateTime.getcurrentDate()
        },
        resetFilter(){
            this.$refs.statusOpted.forEach(opt => {
                opt.checked = (opt.value === this.selectedStatus)
            })
            this.$refs.transactionStatusOpted.forEach(opt => {
                opt.checked = (opt.value === this.selectedTransactionType)
            })
            this.formDates = JSON.parse(JSON.stringify(this.selectedDates))
        },
        getTransactionStatus,
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        },
        async cancelRequest(id){
            try{
                let response = await cancelRequest(id);
                this.getWalletHistory()
            }
            catch(error){
                console.log('cancelRequest', error)
            }
        },
        handleRefreshWalletHistory(index) {
            let spinElem = document.getElementById('spin'+index)
            spinElem.classList.add('fa-spin')
            const spinTimeout = setTimeout(() => {
                spinElem.classList.remove('fa-spin')
                clearTimeout(spinTimeout);
            }, 2000);
            this.getWalletHistory()
        },
        async getWalletHistory() {
            try{
                this.$store.dispatch('setGlobalLoader', true)
                this.selectedDates = JSON.parse(JSON.stringify(this.formDates))
                let response = await getWalletHistory(this.formDates)
                this.$store.dispatch('setGlobalLoader', false)
                if(!response?.error){
                    this.walletHistoryData= response.walletHistoryData
                    this.selectedStatus = this.$refs.statusOpted?.find(opt => opt.checked)?.value || 'all';
                    this.selectedTransactionType = this.$refs.transactionStatusOpted?.find(opt => opt.checked)?.value || 3;
                    if(this.selectedStatus == 'processing'){
                        this.walletHistoryData = this.walletHistoryData.filter((history) => ['reject_in_process','approve_in_process','hold'].includes(history.status))
                    }
                    else if(!['all', 'processing'].includes(this.selectedStatus)){
                        this.walletHistoryData = this.walletHistoryData.filter((history) => history.status == this.selectedStatus)
                    }
                    if(this.selectedTransactionType == 1){
                        this.walletHistoryData = this.walletHistoryData.filter((history) => ['client_deposit','manual_deposit'].includes(history.type))
                    }
                    else if(this.selectedTransactionType == 2){
                        this.walletHistoryData = this.walletHistoryData.filter((history) => ['client_withdrawal','manual_withdrawal'].includes(history.type))
                    }
                }
            }
            catch(error){
                this.$store.dispatch('setGlobalLoader', false)
                console.log(error)
            }
        },
        gotoTransactionDetails(transaction){
            if(transaction.status == "pending") { this.$errorToast('Pending Status Details Are Currently Unavailable'); return; };
            this.$store.dispatch('setTransactionDetails', {...transaction});
            this.$router.push({ 
                name: 'TransactionDetails', 
                params: { id: transaction.c_a_tid } 
            })
        }
    },
}
</script>

<style scoped>
.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db;
    border: 1px solid #3498db;
    color: white;
}

.active-page:hover {
    background-color: #2988c8;
}
.transactionsInformation-delete img{
  width: 18px;
}

</style>